<header class="header">
  <div class="header__container">

    <div class="header__logo" (click)="navigateToMain()">
      <div class="header__wordmark" aria-label="EcoFeast">
        <span class="header__logo-eco">eco</span>
        <span class="header__logo-feast">feast</span>
      </div>
    </div>

    <div class="header__controls">
      <ng-container *ngIf="isLoggedIn() && isLoggedInUser(); else authButtons">
        <div class="header__user-avatar-container">
          <div class="header__user-avatar" (click)="onAvatarClick()" [class.open]="isDropdownOpen">
            <app-icon name="account-circle-outline" [size]="IconSize.Medium"></app-icon>
          </div>

          <div class="header__user-dropdown" *ngIf="isDropdownOpen">
            <app-header-item icon="account-outline" label="profile" link="/profile"></app-header-item>
            <app-header-item *ngIf="isChef$ | async" icon="book-outline" label="myRecipes" link="/my-recipes"></app-header-item>
            <app-header-item icon="heart-outline" label="savedRecipes" link="/saved-recipes"></app-header-item>
            <app-header-item icon="cog-outline" label="settings" link="/settings"></app-header-item>
            <app-header-item icon="help-circle-outline" label="help" link="/help"></app-header-item>
            <app-header-item icon="logout" label="logout" (action)="logout()"></app-header-item>
          </div>
        </div>
      </ng-container>

      <ng-template #authButtons>
        <div class="header__auth-desktop">
          <app-button [skin]="ButtonSkin.Secondary" [size]="ButtonSize.Medium" (click)="navigateToDownload()">{{ 'sidebar.download' | translate }}</app-button>
          <app-language-selector></app-language-selector>
        </div>
        <div class="header__auth-mobile">
          <app-language-selector class="header__language-compact"></app-language-selector>
          <div class="header__hamburger" (click)="toggleMobileSidebarLoggedOut()">
            <app-icon name="menu" [size]="IconSize.Medium"></app-icon>
          </div>
        </div>
      </ng-template>

    </div>

  </div>
</header>


